<template>
  <div>
    <v-container>
      <div v-if="!selected">
        <v-layout>
          <v-flex class="form-control">
            <input type="text" v-model="search" :placeholder="$t('Search')" />
          </v-flex>
          <v-flex>
            <v-btn
              @click="
                pageNumber = 1
                getLiveAuction()
              "
              color="primary"
            >
              {{ $t('Search') }}
            </v-btn>
          </v-flex>
        </v-layout>
        <div v-if="loading">
          <!-- <vue-skeleton-loader type="rect" :height="200" animation="fade" /> -->
          <div class="spinner text-xs-center mb-5 mt-5">
            <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
          </div>
        </div>
        <div v-else>
          <div class="text-xs-right mb-2">
            <v-pagination
              :total-visible="10"
              v-model="pageNumber"
              :length="pagelength"
              @input="changePage"
            ></v-pagination>
          </div>
          <template v-for="(auction, index) in filterAllAuctions">
            <div
              :key="'auctions_' + index"
              class="intent-item z-border-red add-conversation"
              style="padding: 10px 15px 10px;"
            >
              <v-layout>
                <v-flex xs1 style="display: flex;">
                  <i
                    v-if="auction.auction_status === 'active'"
                    class="fas fa-circle"
                    style="color:green"
                  ></i>
                  <i
                    v-if="auction.auction_status === 'close'"
                    class="fas fa-circle"
                    style="color:red"
                  ></i>
                </v-flex>
                <v-flex xs11>
                  <tr
                    wrap
                    style="cursor: pointer"
                    @click="
                      auctionSelect = null
                      selected = false
                      auctionSelect = auction
                      selectedAuction()
                    "
                  >
                    <td xs12 style="color:#000; display: flex;">
                      <h3>{{ $t('auction_name') }} :</h3>
                      <span style="margin-top: 4px; margin-left: 10px; font-weight: bold;">{{
                        auction.auction_title
                      }}</span>
                    </td>
                    <td xs12 style="color:#000; display: flex;">
                      <h3 style="min-width: 100px;">{{ $t('post_name') }} :</h3>
                      <span style="margin-top: 4px; margin-left: 10px;">{{
                        postidlist(auction)
                      }}</span>
                    </td>
                    <td xs12 sm6 style="color:#000; display: flex;">
                      <h3>{{ $t('bank_account_name') }} :</h3>
                      <span style="margin-top: 4px; margin-left: 10px;">
                        {{ auction.bank_account_name }}</span
                      >
                    </td>
                    <td xs12 sm6 style="color:#000; display: flex;">
                      <h3>{{ $t('bank_name') }} :</h3>
                      <span style="margin-top: 4px; margin-left: 10px;">
                        {{ auction.bank_name }}</span
                      >
                    </td>
                    <td xs12 sm6 style="color:#000; display: flex;">
                      <h3>{{ $t('bank_account_number') }} :</h3>
                      <span style="margin-top: 4px; margin-left: 10px;">
                        {{ auction.bank_account_number }}</span
                      >
                    </td>
                  </tr>
                </v-flex>
              </v-layout>
            </div>
          </template>
          <div class="text-xs-right">
            <v-pagination
              :total-visible="10"
              v-model="pageNumber"
              :length="pagelength"
              @input="changePage"
            ></v-pagination>
          </div>
        </div>
      </div>
      <div v-else>
        <DashboardAuctionDetail
          @getLiveAuction="getLiveAuction"
          v-if="auctionSelect"
          v-model="auctionSelect"
          @changeOtherAuction="changeOtherAuction"
        ></DashboardAuctionDetail>
      </div>

      <v-dialog v-model="isShow" persistent scrollable max-width="1000px">
        <v-card v-if="isShow">
          <v-card-title>
            <v-layout>
              <v-flex class="form-control">
                <input type="text" v-model="search" :placeholder="$t('Search')" />
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: 300px;">
            <div
              class="z-border-red"
              style="padding: 15px; margin-bottom: 15px; position: relative;cursor: pointer"
              v-for="(auction, index) in filterAllAuctions"
              :key="'published_post_' + index"
              @click="
                auctionSelect = null
                selected = false
                auctionSelect = auction
              "
            >
              <v-layout wrap>
                <v-flex xs1 sm1>
                  <v-btn
                    fab
                    depressed
                    small
                    :outline="auctionSelect !== auction"
                    color="primary"
                    class="extra-small ma-0"
                  >
                    <i class="fas fa-check"></i>
                  </v-btn>
                </v-flex>
                <v-flex xs11 sm11>
                  <div style="padding-left: 10px;word-break: break-all;">
                    <a
                      :href="'https://www.facebook.com/' + auction.id"
                      target="_blank"
                      rel="noopener noreferrer"
                      :title="auction.auction_title"
                      >{{ auction.auction_title | truncate(200) }}</a
                    >
                  </div>
                </v-flex>
              </v-layout>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey" outline @click="isShow = false">{{ $t('cancel') }}</v-btn>
            <v-btn color="primary" depressed @click="selectedAuction">{{ $t('Select') }}</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import DashboardAuctionDetail from '@/components/view/liveAuction/DashboardAuctionDetail'
import { cloneDeep } from 'lodash'

export default {
  props: ['auctionId'],
  data() {
    return {
      limit: 10,
      offset: 0,
      pageNumber: 1,
      pagelength: 0,
      loading: false,
      isShow: false,
      allAuctions: null,
      search: '',
      auctionSelect: null,
      selected: false
    }
  },
  components: {
    DashboardAuctionDetail
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    filterAllAuctions: function() {
      return this.allAuctions
    }
  },
  mounted() {
    const vm = this
    vm.getLiveAuction()
  },
  methods: {
    postidlist(auction) {
      if (auction && auction.postidlist && JSON.parse(auction.postidlist)) {
        return JSON.parse(auction.postidlist).name
      }
    },
    changePage() {
      const vm = this
      vm.offset = vm.pageNumber * vm.limit - vm.limit
      vm.getLiveAuction()
    },
    selectedAuction() {
      const vm = this
      if (vm.auctionSelect) {
        vm.selected = true
        vm.isShow = false
      }
    },
    changeOtherAuction() {
      const vm = this
      vm.getLiveAuction()
      vm.selected = false
    },
    async getLiveAuction() {
      const vm = this
      vm.loading = true
      vm.data = null
      const data = {
        pageid: vm.selectedBot.pageid,
        params: {
          with_product: false,
          filter_status: 'active,close',
          filter_name: vm.search || '',
          limit: vm.limit,
          offset: vm.offset
        }
      }
      let response = await api.getLiveAuction(data)
      if (response.success && response.result) {
        vm.allAuctions = response.result
        if (vm.auctionId) {
          const auction = response.result.filter(el => el.id === parseInt(vm.auctionId))
          if (auction.length > 0) {
            vm.auctionSelect = auction[0]
            vm.selectedAuction()
            vm.$emit('update:auctionId', null)
          }
        }
        vm.pagelength = Math.ceil(response.total_count / vm.limit)
      }
      vm.loading = false
    }
  }
}
</script>

<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// src/components/view/liveAuction/DashboardAuction.vue